import { BillOrderMode } from '../../billing-center/balance';

export enum OrderType {
  New = 1,
  Renew = 2,
}

export enum OrderStatus {
  NORMAL = 1, // 正常
  REVIEW = 2, // 审核中
  REVIEW_FAIL = 3, // 审核驳回
  LOADING = 4, // 待确认/待支付
  FAIL = 5, // 交易失败
  CANCEL = 6, // 交易取消
  OVERDUE = 7, // 欠费
  STOP = 8, // 停服
}

export interface IApiOrderListItem {
  create_time: string;
  env_id: number;
  freeze_amount: number | null;
  game_id: number;
  midas_pay_fail_detail: string;
  midas_pay_fail_type: number;
  order_count: number | null;
  order_creator: string;
  order_id: string;
  order_mode: BillOrderMode;
  order_package: null;
  order_status: OrderStatus;
  order_type: OrderType;
  order_unit_price: number;
  overdue_days: number | null;
  service_id: number;
  service_name: string;
  studio_id: string;
  subservice_name: string | null;
  update_time: string;
}
